module.exports = __webpack_public_path__ + "img/greenchannel.5b18bbbe.png";